import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Heart } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">V</span>
              </div>
              <span className="text-white font-bold text-xl">Voxel</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Level up your Discord server with games, giveaways, global economy, and nonstop fun in one powerful bot.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://discord.gg/CfnpERCY7r"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors flex items-center gap-2"
              >
                <ExternalLink className="w-4 h-4" />
                Support Server
              </a>
              <a
                href="https://top.gg/bot/1323444656070983701"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors flex items-center gap-2"
              >
                <ExternalLink className="w-4 h-4" />
                Top.gg
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/commands" className="text-gray-400 hover:text-white transition-colors">
                  Commands
                </Link>
              </li>
              <li>
                <Link to="/premium" className="text-gray-400 hover:text-white transition-colors">
                  Premium
                </Link>
              </li>
              <li>
                <Link to="/stocks" className="text-gray-400 hover:text-white transition-colors">
                  Stocks
                </Link>
              </li>
              <li>
                <a
                  href="https://discord.com/oauth2/authorize?client_id=1323444656070983701"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Add to Server
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Voxel Bot. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm flex items-center gap-1 mt-4 md:mt-0">
            Made with <Heart className="w-4 h-4 text-red-400" fill="currentColor" /> by Tom
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
